import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CONSTANTS from "../../../constants";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import fetchApiData from "../../apiHandlers/fetchApiData";
import Button from "../../Forms/Button";
import InputOutlined from "../../Forms/InputOutlined";
import Radio from "../../Forms/Radio";
import Select from "../../Forms/Select";
import PopUp from "../../popup/popup";
import {
  setVeiculeInfos,
  setVeiculeKilo,
  CurrentStepSetAction,
  setFilterDealersBy,
} from "./../../../actions/action";
import "./ModelTabFlex.scss";

const mapStateToProps = (state) => state;
const mapDispatchToProps = {
  setVeiculeInfos,
  setVeiculeKilo,
  CurrentStepSetAction,
  setFilterDealersBy,
};

const ModelTabFlex = (props) => {
  const loadModels = () => {
    const ModelsDetails = new fetchApiData();
    ModelsDetails.getModels()
      .then((data) => {
        if (_isMounted) {
          let Data = [];
          Data["0"] = "- " + CONSTANTS.LABELS.vehicule_model_select_option;

          if (data.d.length) {
            setAllModels(data.d);
            data.d.map(function(item) {
              Data[item.Value] = item.Text;
            });
          }
          setModelData(Data);
          setStep1Loading(false);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        setStep1Loading(false);
      });
  };

  let _isMounted = false;
  const [showFiltersPopup, setShowFiltersPopup] = useState(false);
  const [allModels, setAllModels] = useState([]);
  const [allEnergydata, setAllEnergydata] = useState([]);
  const [isActivateRecallCampaign, setIsActivateRecallCampaign] = useState(
    !!Number(CONSTANTS.SITE_CONFIG.ActivateRecallCampaign)
  );
  const [MarkInput, setMarkInput] = useState(CONSTANTS.SITE_INFO.BRAND_CODE);
  const [ModelInput, setModelInput] = useState("0");
  const [ModelData, setModelData] = useState(loadModels() || {});
  const [EnableEnergyInput, setEnableEnergyInput] = useState(false);
  const [EnergyInput, setEnergyInput] = useState("0");
  const [EnergyData, setEnergyData] = useState({});
  const [step1Loading, setStep1Loading] = useState(false);
  const [step2ButtonDisabled, setStep2ButtonDisabled] = useState(true);
  const [immaInput, setImmaInput] = useState("");
  const [matriculeCodeError, setMatriculeCodeError] = useState(false);
  const [KilometrageError, setKilometrageError] = useState(false);
  const [kilometrage, setKilometrage] = useState(
    props.store.kilo.kilometrage ? props.store.kilo.kilometrage : ""
  );
  const [contratSerivce, setContratSerivce] = useState(
    Object.values(props.store.kilo).length > 0 &&
      props.store.kilo.contratService
      ? true
      : false
  );
  const [isVehiclePC, setIsVehiclePC] = useState(
    props.store.car.PC === undefined ? false : props.store.car.PC
  );
  const [isVehicleLCV, setIsVehicleLCV] = useState(
    props.store.car.LCV === undefined ? false : props.store.car.LCV
  );
  const [otherEnergyInput, setOtherEnergyInput] = useState("");
  const [otherModelInput, setOtherModelInput] = useState("");
  const [didChooseOtherModel, setDidChooseOtherModel] = useState(false);

  let isActivateFiltersVPVU = props.store.listPremiumServices.some(
    (item) =>
      (item.codeIntern === "PC" || item.codeIntern === "LCV") && item.displayDL
  );

  let selectedModelOrMotor = {};

  useEffect(() => {
    _isMounted = true;

    setModelInput(props.prevData.ModelInput);
    setEnergyInput(props.prevData.EnergyInput);
    setStep2ButtonDisabled(
      Object.values(props.store.kilo).length ? false : true
    );
    if (props.prevData.ModelInput !== undefined)
      loadMotos(props.prevData.ModelInput);

    //Si le modèle est autre, préremplir les infos
    if (
      (props.store.car.BrandCode === "O" || !props.store.car.MotorCode) &&
      props.prevData.EnergyInput !== undefined &&
      props.prevData.ModelInput !== undefined
    ) {
      setMarkInput("O");
      setEnergyInput(props.store.car.EnergyLabel);
      setModelInput(props.store.car.ModelLabel);
      setDidChooseOtherModel(true);
    } else {
      //Si peugeot à Autre
      setEnergyInput(props.store.car.MotorCode);
      setModelInput(props.store.car.ModelCode);
    }
    setStep1Loading(true);

    return () => {
      _isMounted = false;
    };
  }, []);

  const loadMotos = (motoCode) => {
    const MotosDetails = new fetchApiData();
    setStep1Loading(true);
    MotosDetails.getMotos(motoCode)
      .then((data) => {
        let Data = [];
        Data[0] = "- " + CONSTANTS.LABELS.vehicule_model_select_option;
        if (data.d.length) {
          setAllEnergydata(data.d);
          data.d.map(function(item) {
            Data[item.Value] = item.Text;
          });
        }
        setStep1Loading(false);
        setEnergyData(Data);
      })
      .catch((error) => {
        console.log("Error: ", error);
        setStep1Loading(false);
      });
  };

  const validStep = () => {
    if (isActivateFiltersVPVU && MarkInput != "O") {
      if (CONSTANTS.SITE_INFO.BRAND_CODE !== "V") {
        selectedModelOrMotor = allModels.filter(
          (model) => model.Value === ModelInput
        );
        if (
          !(
            selectedModelOrMotor[0].PC === props.store.dealer.PC ||
            selectedModelOrMotor[0].LCV === props.store.dealer.LCV
          )
        ) {
          setShowFiltersPopup(true);
          setIsVehicleLCV(selectedModelOrMotor[0].LCV);
          setIsVehiclePC(selectedModelOrMotor[0].PC);
          document.body.classList.add("no-scroll");
        } else props.CurrentStepSetAction(4);
      } else if (CONSTANTS.SITE_INFO.BRAND_CODE === "V") {
        selectedModelOrMotor = allEnergydata.filter(
          (motorEnergy) => motorEnergy.Value === EnergyInput
        );
        if (
          !(
            selectedModelOrMotor[0].PC === props.store.dealer.PC ||
            selectedModelOrMotor[0].LCV === props.store.dealer.LCV
          )
        ) {
          setShowFiltersPopup(true);
          setIsVehicleLCV(selectedModelOrMotor[0].LCV);
          setIsVehiclePC(selectedModelOrMotor[0].PC);
          document.body.classList.add("no-scroll");
        } else props.CurrentStepSetAction(4);
      }
    } else {
      props.CurrentStepSetAction(4);
    }
    props.setVeiculeInfos({
      PC:
        isActivateFiltersVPVU && MarkInput != "O"
          ? selectedModelOrMotor[0].PC
          : false,
      LCV:
        isActivateFiltersVPVU && MarkInput != "O"
          ? selectedModelOrMotor[0].LCV
          : false,
      Mileage: null,
      SerialNumber: "",
      HasServiceContract: null,
      BrandLabel: window.siteConfig.brand,
      BrandCode: MarkInput,
      ModelCode: MarkInput != "O" ? ModelInput : "",
      ModelLabel: MarkInput != "O" ? ModelData[ModelInput] : ModelInput,
      EnergyLabel: MarkInput != "O" ? EnergyData[EnergyInput] : EnergyInput,
      MotorCode: MarkInput != "O" ? EnergyInput : "",
      Lcdv: "",
      Registration: "",
    });
  };

  const continueToNextStep = () => {
    setShowFiltersPopup(false);
    document.body.classList.remove("no-scroll");
    props.CurrentStepSetAction(4);
  };

  const goToDealersLocator = () => {
    props.store.listPremiumServices.forEach((item) => {
      if (item.codeIntern === "LCV" && isVehicleLCV) {
        if (props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
          props.setFilterDealersBy([
            ...props.store.filterDealersBy,
            item.idServicePremium,
          ]);
        }
      }
      if (item.codeIntern === "PC" && isVehiclePC) {
        if (props.store.filterDealersBy.indexOf(item.idServicePremium) === -1) {
          props.setFilterDealersBy([
            ...props.store.filterDealersBy,
            item.idServicePremium,
          ]);
        }
      }
    });
    props.CurrentStepSetAction(1);
  };

  const { brand, currentBrand } = window.siteConfig;
  const brandChoices = {
    [currentBrand]: brand.toLowerCase() === "citroen" ? "Citroën" : brand,
    O: CONSTANTS.LABELS.vehicule_model_select_other,
  };
  const popInFilterContent = (
    <div className="warning-filters">
      <p className="warning-main">
        {CONSTANTS.LABELS.vehicule_filter_alert_main}
      </p>
      <div className="warning-list">
        <p className="warning-second">
          {CONSTANTS.LABELS.vehicule_filter_alert_second}
        </p>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_warranty}
          </span>
        </li>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_maintenance}
          </span>
        </li>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_recall_campain}
          </span>
        </li>
        <li className="warning-item">
          <i className="mark-icons cross-icon" />
          <span className="warning-label">
            {CONSTANTS.LABELS.vehicule_filter_alert_package}
          </span>
        </li>
      </div>
    </div>
  );

  return (
    <div className="flexContainer">
      <p
        tabIndex="0"
        className="campaignRecall"
        dangerouslySetInnerHTML={{
          __html: CONSTANTS.LABELS.vehicule_step2recalleligibilitywarning,
        }}
      ></p>
      <p
        tabIndex="0"
        className="sectionIntro"
        dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.vehicule_label1 }}
      ></p>

      <div className="selectOutlinedContainer">
        <Select
          customClassName={"selectDropdown"}
          Options={brandChoices}
          Selected={MarkInput}
          Name="mark"
          ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_brand}
          onChange={(e) => {
            setMarkInput(e.target.value);
            //Si Peugeot à autre
            if (e.target.value === "O") {
              // Vérifier si la personne est passée par modèle initialement
              if (
                props.store.car.BrandLabel !== null &&
                props.store.car.BrandLabel !== "O"
              ) {
                //Vérifier si Toujours Opel
                if (didChooseOtherModel === false) {
                  //Ne pas afficher les infos du modele dans autre
                  setEnergyInput("");
                  setModelInput("");
                } else {
                  //Si la personne a choisi un autre modele, afficher les infos
                  setEnergyInput(props.store.car.EnergyLabel);
                  setModelInput(props.store.car.ModelLabel);
                }
              } else {
                setEnergyInput(props.store.car.EnergyLabel);
                setModelInput(props.store.car.ModelLabel);
              }
            } else {
              //Si autre à peugeot
              setEnergyInput(props.store.car.MotorCode);
              setModelInput(props.store.car.ModelCode);
            }
          }}
        />
        <span className="selectOutlinedTitle">
          {CONSTANTS.LABELS.vehicule_model_step1_label_brand}
        </span>
      </div>

      {MarkInput != "O" ? (
        <div className="selectOutlinedContainer">
          <Select
            customClassName={"selectDropdown"}
            Options={ModelData}
            Selected={ModelInput || "0"}
            ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_model}
            onChange={(e) => {
              if (e.target.value.trim() !== "0") {
                loadMotos(e.target.value);
                setModelInput(e.target.value);
                setEnergyInput("0");
              }

              props.dataFromChild({
                EnergyInput: false,
                ModelInput: e.target.value,
              });
            }}
          />
          <span className="selectOutlinedTitle">
            {CONSTANTS.LABELS.vehicule_model_step1_label_model}
          </span>
        </div>
      ) : (
        <div className="subContainer">
          <InputOutlined
            placeholder=""
            title={CONSTANTS.LABELS.vehicule_model_step1_label_model}
            ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_model}
            onChange={(e) => {
              props.dataFromChild({
                EnergyInput: false,
                ModelInput: e.target.value,
              });
              setModelInput(e.target.value);
            }}
            value={ModelInput}
          />
        </div>
      )}

      {MarkInput != "O" ? (
        <div className="selectOutlinedContainer">
          <Select
            customClassName={"selectDropdown"}
            Options={EnergyData}
            Disabled={ModelInput == "0"}
            ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_energy}
            Selected={EnergyInput || "0"}
            onChange={(e) => {
              setEnergyInput(e.currentTarget.value);
              props.dataFromChild({
                EnergyInput: e.currentTarget.value,
                ModelInput: ModelInput,
              });
            }}
          />
          <span className="selectOutlinedTitle">
            {CONSTANTS.LABELS.vehicule_model_step1_label_energy}
          </span>
        </div>
      ) : (
        <div className="subContainer">
          <InputOutlined
            placeholder=""
            ariaLabel={CONSTANTS.LABELS.vehicule_model_step1_label_energy}
            title={CONSTANTS.LABELS.vehicule_model_step1_label_energy}
            onChange={(e) => {
              setEnergyInput(e.target.value);
            }}
            value={EnergyInput}
          />
        </div>
      )}

      <div className="subContainer">
        <InputOutlined
          title={CONSTANTS.LABELS.vehicule_step2_km1}
          name="distance"
          type="tel"
          ariaLabel={CONSTANTS.LABELS.vehicule_step2_km1}
          selected={kilometrage}
          isInvalid={KilometrageError}
          onChange={(e) => {
            setKilometrage(e.target.value);

            if (
              e.target.value.trim().length &&
              (Number(e.target.value) > 999999 ||
                e.target.value.trim().length > 6)
            ) {
              setStep2ButtonDisabled(true);
              setKilometrageError(
                CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
              );
            } else if (
              e.target.value.trim().length &&
              !/^[0-9]*$/.test(e.target.value)
            ) {
              setStep2ButtonDisabled(true);
              setKilometrageError(
                CONSTANTS.LABELS.vehicule_step2_error_numbersonly
              );
            } else if (
              e.target.value.trim().length &&
              Number(e.target.value) === 0
            ) {
              setStep2ButtonDisabled(true);
              setKilometrageError(CONSTANTS.LABELS.vehicule_step2_error_zero);
            } else {
              setStep2ButtonDisabled(false);
              setKilometrageError(false);
            }
          }}
        />
      </div>

      <div className="radioContainer">
        <span tabIndex="0" className="styleLabel">
          {CONSTANTS.LABELS.vehicule_step2_warranty}
        </span>

        <div className="radioSubContainer">
          <Radio
            name="servieContract"
            id="servieContract-0"
            label={CONSTANTS.LABELS.vehicule_step2_warranty_yes}
            customClassName="marginButton"
            isChecked={!!contratSerivce}
            onChange={(e) => {
              setContratSerivce(true);
            }}
          />
          <Radio
            name="servieContract"
            id="servieContract-1"
            label={CONSTANTS.LABELS.vehicule_step2_warranty_no}
            isChecked={!contratSerivce}
            onChange={(e) => {
              setContratSerivce(false);
            }}
          />
        </div>
      </div>

      <div className="notInPopup">
        <Button
          onClick={() => {
            validStep();
            props.setVeiculeKilo({
              contratService: contratSerivce,
              kilometrage: kilometrage,
              carStep: "3",
            });
            props.updateServicesAfterDataChanged();
            pushEventToGTM({
              pageName: "car-details",
              eventAction: "Redirection::Internal::Next_step",
              eventLabel: "model",
            });
          }}
          Disabled={
            step2ButtonDisabled ||
            kilometrage.length < 1 ||
            EnergyInput == "0" ||
            EnergyInput == "" ||
            ModelInput == "0" ||
            ModelInput == ""
          }
        >
          {CONSTANTS.LABELS.common_v2_nextstep}
        </Button>
      </div>

      {// filter LCV/PC incompatibility between vehicle and dealer
      showFiltersPopup && (
        <PopUp
          title={CONSTANTS.LABELS.vehicule_filter_alert_title}
          content={popInFilterContent}
          primaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_other_dealer}
          secondaryButtonLabel={CONSTANTS.LABELS.vehicule_filter_ignore}
          handlePrimaryButton={() => goToDealersLocator()}
          handleSecondaryButton={() => {
            continueToNextStep("filterPopin");
          }}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ModelTabFlex);
